import React from "react";
import Select from "@peracto/peracto-editor-ui/dist/Select";

const CallbirdForm = ({ onChange, state: { alignment = "center" } }) => {
    return (
        <Select
            label="Alignment"
            value={alignment}
            onChange={(e) => onChange({ alignment: e.value })}
            options={[
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
            ]}
        />
    );
};

export default CallbirdForm;
